import { render, staticRenderFns } from "./SearchPropertyCard.vue?vue&type=template&id=e113d36c&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform"
import script from "./SearchPropertyCard.vue?vue&type=script&lang=ts"
export * from "./SearchPropertyCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports